import React, { Component } from 'react';
import TableContent from '../../../Components/UI/TableRecord/TableContent';
import Wrp from "../../../hoc/Wrp/Wrp";
class ModalBody extends Component {
    
    render () {
        
        // const modalBody = this.props.modalBody;
        const {preChildren} = this.props;
        return (
            <Wrp>
                {(preChildren!==false)?
                    preChildren
                :''}
                
                       
                       
                {/*
                    {(this.props.isConfirmPage===false)?
                        
                    <div className="dataTables_length p-2">
                        <label className="pl-0">Total Records :  <span className="badge badge-warning p-1 secondary_color"> {this.props.tableRecords.pagination.totalRecords}  </span> </label>
                    </div>
                         
                    :''}   
                */}
                                   
                                
                                
                            
                                
                <div className="table-responsive nowrap border">
                    <TableContent {...this.props} margin={"popup-table"}/>
                </div>
                                     

                                
                            
                           
                      
            </Wrp>
       
            
        )
    }
}

export default ModalBody;